"use client";

import { useFeedback } from "@/components/feedback/FeedbackProvider";

export default function FeedbackButton({ className = "", children = "Give feedback", source = "inline" }: { className?: string; children?: React.ReactNode; source?: string }) {
  const { openFeedback } = useFeedback();
  return <button type="button" onClick={() => openFeedback({ source })} className={className}>{children}</button>;
}
